<template>
  <section class="creation-guide-bar pc-only">
    <h2 class="creation-guide-bar__title">
      <span>现在就用它创建你的专属{{ is2DHuman ? '' : '3D' }}数字人</span>
      <Resource
        :src="getFeUrl('/youyan-platform/character-intro/character-detail/title-avatar-3x.png')"
        alt="avatar"
        class="creation-guide-bar__title-img"
      />
      <span>视频</span>
    </h2>
    <p class="creation-guide-bar__desc">
      让它用自然声音
      <Resource
        :src="
          getFeUrl('/youyan-platform/character-intro/character-detail/title-avatar-group-3x.png')
        "
        alt="natural-group"
      />
      流畅动作和生动表情，精准呈现你的每个想法
    </p>
    <UpgradeButton
      :configType="props.character?.config_type"
      @handle="emits('create-work')"
      class="creation-guide-bar__btn"
      text="免费试用"
    />
  </section>
</template>

<script setup lang="ts">
import type { Character } from '@/api/interface/character';
import UpgradeButton from '@/components/upgrade-button/index.vue';
import { getFeUrl } from '@/utils/url';

const props = defineProps<{
  character?: Character | null;
  is2DHuman?: boolean;
}>();

const emits = defineEmits(['create-work']);
</script>

<style lang="scss" scoped>
.creation-guide-bar {
  @apply flex-col items-center py-[80px] min-w-[1200px];
}
.creation-guide-bar__title {
  @apply flex justify-center gap-4 items-end;
  color: var(--x-text-1);
  text-align: center;
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  margin-bottom: 32px;
  img {
    width: 125px;
    height: 126px;
    margin-bottom: 9px;
  }
}
.creation-guide-bar__desc {
  @apply flex-center gap-4;
  color: var(--x-text-5);
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  img {
    width: 102.5px;
    height: 40px;
  }
}
.creation-guide-bar__btn {
  margin-top: 40px;
}
</style>
